import { GroupTicketProperties } from "./GroupTicketProperties"

export class GroupTitleProperties {
  groupTitleId: number
  groupTitle: string
  groupImageName: string 
  groupImagePath: string
  imageFile: string
}

export interface GroupTitleDetailsInterface {
  image: string; // Base64 image string
  tickets: GroupTicketProperties[]; // Array of tickets
};


export class GroupFilterTabs {
  groupTitle: string
  imageFile: string
  totalTickets: number
  remainingTickets: number
}
